export default "__VITE_ASSET__DlwxJTT6__"